import styled from 'styled-components';
import { theme, palette } from 'styled-tools';

const S = {};

S.Tag = styled.span`
  font-family: ${theme('fontFamily')};
  font-weight: ${theme('fontWeight.bold')};
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 2px 4px;
  background-color: ${palette('primary')};
  color: ${palette('light')};
  border-radius: ${theme('borderRadius.sm')};
`;

export default S;
